var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "resort-locations" },
        [
          _c("locations-map", {
            attrs: {
              zoom: "12",
              locations: _vm.locations,
              center: _vm.resort.$attributes.location,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }